import { render, staticRenderFns } from "./project-note.vue?vue&type=template&id=48ca0532&"
import script from "./project-note.vue?vue&type=script&lang=js&"
export * from "./project-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports